/* src/app/views/template/components/edit-template-menu/edit-template-card-stack-menu/edit-template-card-stack-menu-footer/edit-template-card-stack-menu-footer.component.scss */
/*# sourceMappingURL=edit-template-card-stack-menu-footer.component.css.map */
